module["exports"] = [
  "#{street_preffix} #{Name.first_name}",
  "#{street_preffix} #{Name.last_name}"
];
